'use strict';

export const initLocalizationTransition = ($transitionsProvider) => {
	let initLocalization = async (transition) => {
		const authService = transition.injector().get('mx.shell.AuthService');
		const i18nService = transition.injector().get('mx.shell.InternationalizationService');
		const userProfileService = transition.injector().get('mx.shell.UserProfileService');
		let languageId;

		if (await authService.isAuthenticated()) {
			const userInfo = await userProfileService.get();
			languageId = userInfo.languageId;
		} else {
			const language = await i18nService.getSupportedBrowserLanguage();
			languageId = language.id;
		}

		await i18nService.initLocalization(languageId);
	};

	$transitionsProvider.onBefore({}, initLocalization, { priority: 50 });
};
